import React from "react";
import LandingCategory from "../components/common/LandingCategory";
import { themes } from "../themes/themes";
import avatarFeminino from "../assets/images/feminino-avatar.png";
import useTrackPageView from "../hooks/useTrackPageView";
import useTimeOnPage from "../hooks/useTimeOnPage";
import { trackEvent } from "../lib/analytics";

export default function Feminino() {
    useTrackPageView();
    useTimeOnPage();

    const handleWhatsappClick = async () => {
        await trackEvent("whatsapp_click", {
            buttonLocation: "masculino_cta_main",
        });

        window.open("https://chat.whatsapp.com/seu-link", "_blank");
    };
    return (
        <LandingCategory
            avatar={avatarFeminino}
            titleTop="CHEGA DE PAGAR"
            titleBottom="CARO EM MODA!"
            highlightWord="EM MODA!"
            members="250.000"
            description="Entre no grupo VIP e receba ofertas selecionadas todos os dias! ✨"
            whatsappLink="https://chat.whatsapp.com/seu-link"
            telegramLink="https://t.me/seu-link"
            theme={themes.feminino}
            onWhatsappClick={handleWhatsappClick}
        />
    );
}